import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React, { useEffect } from 'react';
import classnames from 'classnames';
import Text from "../../components/Typography/Text";
import { Container, Link, Icon } from "../../components/Common";
import { NOTIFICATION_TYPE } from '../notificationType';
import styles from './NotificationItem.scss';
import iconTypeError from './img/error.svg';
import iconTypeInfo from './img/info.svg';
import iconTypeWarning from './img/warning.svg';
import iconTypeSuccess from './img/success.svg';

var getIcon = function getIcon(type) {
  if (type === NOTIFICATION_TYPE.info) {
    return iconTypeInfo;
  }

  if (type === NOTIFICATION_TYPE.error) {
    return iconTypeError;
  }

  if (type === NOTIFICATION_TYPE.success) {
    return iconTypeSuccess;
  }

  if (type === NOTIFICATION_TYPE.warning) {
    return iconTypeWarning;
  }

  return null;
};

var NotificationItem = function NotificationItem(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? NOTIFICATION_TYPE.info : _ref$type,
      message = _ref.message,
      onClose = _ref.onClose,
      duration = _ref.duration;
  useEffect(function () {
    if (duration) {
      var timerId = setTimeout(onClose, duration);
      return function () {
        return clearTimeout(timerId);
      };
    }

    return function () {};
  }, [onClose, duration]);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.Notification, styles["Notification_type_".concat(type)])
  }, /*#__PURE__*/React.createElement("img", {
    src: getIcon(type),
    className: styles.icon,
    alt: type
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    inline: true
  }, typeof message === 'string' ? message : message.text), _typeof(message) === 'object' && /*#__PURE__*/React.createElement(Container, {
    marginLeft: 2
  }, /*#__PURE__*/React.createElement(Link, {
    history: !message.isLinkExternal,
    to: message.link
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "accent"
  }, message.linkText)))), !duration && /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    color: "text",
    size: "medium",
    className: styles.close,
    onClick: onClose
  }));
};

export default NotificationItem;